import type { Components, Theme } from '@mui/material';

const menuThemeConfig: Components<Theme>['MuiMenu'] = {
  styleOverrides: {
    root: {},
  },
};

const menuItemThemeConfig: Components<Theme>['MuiMenuItem'] = {
  styleOverrides: {
    root: {
      '&:hover, &.Mui-focusVisible': {
        // TODO: no VDS token for this value (#ccf0f9) — needs designer input (Barry Richardson)
        backgroundColor: '#ccf0f9',
      },
      '&.Mui-selected': {
        backgroundColor: 'transparent',
      },
    },
  },
};

export const muiMenuThemeConfig = {
  MuiMenu: {
    ...menuThemeConfig,
  },
  MuiMenuItem: {
    ...menuItemThemeConfig,
  },
};
